var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.61,
    height: 20.532,
    viewBox: "0 0 17.61 20.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(-294.997 -1686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M17.61,10.241H0V7.035A8.705,8.705,0,0,1,.951,3.093,8.97,8.97,0,0,1,3.494.056,7.164,7.164,0,0,0,8.771,2.368,7.158,7.158,0,0,0,14.1,0a8.776,8.776,0,0,1,2.556,2.992A8.455,8.455,0,0,1,17.61,6.92v3.32Z",
    transform: "translate(294.997 1696.291)",
    fill: "#F28900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M5.484,0a5.413,5.413,0,0,1,5.484,5.338,5.413,5.413,0,0,1-5.484,5.338A5.413,5.413,0,0,1,0,5.338,5.413,5.413,0,0,1,5.484,0Z",
    transform: "translate(298.285 1686)",
    fill: "#F28900"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserActive);
export default __webpack_public_path__ + "static/media/userActive.0e387cbf6ca59eeffa9a567b08ed6ba1.svg";
export { ForwardRef as ReactComponent };